import { EXPENSE_CATEGORY_TABS } from "constants/expenseConstants";

export default function ExpenseCategoryTabs({ activeCategory, onChange }) {
  return (
    <div className="flex flex-wrap gap-2 px-4 pt-4">
      {EXPENSE_CATEGORY_TABS.map((tab) => (
        <button
          key={tab.label}
          type="button"
          onClick={() => onChange(tab.value)}
          className={`px-4 py-2 rounded-lg text-sm font-medium border transition-colors ${
            activeCategory === tab.value
              ? "bg-primary-600 text-white border-primary-600"
              : "bg-white text-gray-600 border-gray-300 hover:border-primary-300"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
